module.exports = "//public.getcloudapp.com/packs/media/images/onboarding/download-windows_color-02d35985dbbd088dda9eecea655df9f7.svg";